import React from "react"

const EquipList = ({ data: { title = null, list } }) => {
  let renderList = []
  let item, nextItem = null

  for (let i = 0; i < list.length; i++) {
    item = list[i]

    if (i !== list.length - 1) {
      nextItem = list[i + 1]

      if (Array.isArray(nextItem)) {
        renderList.push(
          <li key={item}>
            {item.getHTML()}
            <ul>{nextItem.map(el => <li key={el}>{el.getHTML()}</li>)}</ul>
          </li>
        )
        i++
        continue
      }
    }

    renderList.push(<li key={item}>{item.getHTML()}</li>)
  }

  return (
    <div className="equip-list">
      {title && <p>{title}</p>}
      <ul>{renderList}</ul>
    </div>
  )
}

export default EquipList